import { createAsyncThunk } from "@reduxjs/toolkit"

import { showHideLoader } from "../../common/common.slice";
import { overviewTemplateService } from "../../../services/backOffice/overviewTemplate/overviewTemplate.service";

// get project overview details action
const getProjectOverviewTemplateAction = createAsyncThunk(
    'overviewTemplate/getProjectOverviewTemplateAction', (payload: any, { dispatch, rejectWithValue }) => {
        if(payload?.hideLoader){
            dispatch(showHideLoader(true)); 
        }
        return overviewTemplateService.getOverviewTemplateService(payload)
            .then((response) => {
                setTimeout(() => {
                    if(payload?.hideLoader){
                        dispatch(showHideLoader(false));
                    }   
                }, 500)
                return response;
            })
            .catch((error: { response: unknown; }) => {
                setTimeout(() => {
                    if(payload?.hideLoader){
                        dispatch(showHideLoader(false));
                    }   
                }, 500)
                return rejectWithValue(error?.response);
            })
    }
)

// get specific task details action
const getSpecificTaskDetailsAction = createAsyncThunk(
    'overviewTemplate/getSpecificTaskDetailsAction', (payload: any, { dispatch, rejectWithValue }) => {
        dispatch(showHideLoader(true));  
        return overviewTemplateService.getSpecificTaskDetailsService(payload)
            .then((response) => {
                setTimeout(() => {
                    dispatch(showHideLoader(false));
                }, 500)
                return response;
            })
            .catch((error: { response: unknown; }) => {
                setTimeout(() => {
                    dispatch(showHideLoader(false));
                }, 500)
                return rejectWithValue(error?.response);
            })
    }
)

// remove specific task action
const removeSpecificTaskAction = createAsyncThunk(
    'overviewTemplate/removeSpecificTaskAction', (payload: any, { dispatch, rejectWithValue }) => {
        dispatch(showHideLoader(true));
        return overviewTemplateService.removeSpecificTaskService(payload)
            .then((response) => {
                setTimeout(() => {
                    dispatch(showHideLoader(false));
                }, 500)
                return response;
            })
            .catch((error: { response: unknown; }) => {
                setTimeout(() => {
                    dispatch(showHideLoader(false));
                }, 500)
                return rejectWithValue(error?.response);
            })  
    }
)

// update specific task action
const updateTaskAction = createAsyncThunk(
    'overviewTemplate/updateTaskAction', (payload: any, { dispatch, rejectWithValue }) => {
        if(!payload?.hideLoader){
            dispatch(showHideLoader(true)); 
        }
        return overviewTemplateService.updateTaskService(payload)
            .then((response) => {   
                setTimeout(() => {
                    if(payload?.hideLoader){
                        dispatch(showHideLoader(false));
                    }   
                }, 500)
                return response;
            })
            .catch((error: { response: unknown; }) => {
                setTimeout(() => {
                    if(payload?.hideLoader){
                        dispatch(showHideLoader(false));
                    }   
                }, 500)
                return rejectWithValue(error?.response);
            })
    }
)

// duplicate task action
const duplicateTaskAction = createAsyncThunk(
    'overviewTemplate/duplicateTaskAction', (payload: any, { dispatch, rejectWithValue }) => {
        dispatch(showHideLoader(true));
        return overviewTemplateService.duplicateTaskService(payload)
            .then((response) => {
                setTimeout(() => {
                    dispatch(showHideLoader(false));
                }, 500)
                return response;
            })
            .catch((error: { response: unknown; }) => {
                setTimeout(() => {
                    dispatch(showHideLoader(false));
                }, 500)
                return rejectWithValue(error?.response);
            })
    }
)

// get possible predecessors action
const getPossiblePredecessorsAction = createAsyncThunk(
    'overviewTemplate/getPossiblePredecessorsAction', (payload: any, { dispatch, rejectWithValue }) => {
        // dispatch(showHideLoader(true));
        return overviewTemplateService.getPossiblePredecessorsService(payload)
            .then((response) => {
                setTimeout(() => {
                    // dispatch(showHideLoader(false));
                }, 500)
                return response;
            })
            .catch((error: { response: unknown; }) => {
                setTimeout(() => {
                    // dispatch(showHideLoader(false));
                }, 500)
                return rejectWithValue(error?.response);
            })
    }
)

// Add new task action
const AddNewTaskAction = createAsyncThunk(
    'overviewTemplate/AddNewTaskAction', (payload: any, { dispatch, rejectWithValue }) => {
        dispatch(showHideLoader(true));
        return overviewTemplateService.AddNewTaskService(payload)
            .then((response) => {
                setTimeout(() => {
                    dispatch(showHideLoader(false));
                }, 500)
                return response;
            })
            .catch((error: { response: unknown; }) => {
                setTimeout(() => {
                    dispatch(showHideLoader(false));
                }, 500)
                return rejectWithValue(error?.response);
            })
    }
)


export const overviewTemplateActions = {
    getProjectOverviewTemplateAction,
    getSpecificTaskDetailsAction,
    removeSpecificTaskAction,
    updateTaskAction,
    duplicateTaskAction,
    getPossiblePredecessorsAction,
    AddNewTaskAction
}